// src/components/Dashboard/hooks/useWorkspacesMetadata.js
import { useState, useEffect, useCallback } from 'react';

export const useWorkspacesMetadata = (userId, apiUrl) => {
  const [workspacesMetadata, setWorkspacesMetadata] = useState([]);
  const [loadingWorkspacesMeta, setLoadingWorkspacesMeta] = useState(false);
  const [error, setError] = useState(null);

  const refreshWorkspacesMetadata = useCallback(async () => {
    if (!userId) return;
    setLoadingWorkspacesMeta(true);
    setError(null);
    try {
      const response = await fetch(`${apiUrl}/SiteNote/GetStackedWorkspaces?pageNumber=1&pageSize=10000&userId=${userId}`);
      if (!response.ok) throw new Error('Failed to fetch workspace metadata');
      const data = await response.json();
      setWorkspacesMetadata(data.workspaces || []);
    } catch (err) {
      console.error('Error fetching workspace metadata:', err);
      setError(err.message);
    } finally {
      setLoadingWorkspacesMeta(false);
    }
  }, [apiUrl, userId]);

  // Initial fetch
  useEffect(() => {
    refreshWorkspacesMetadata();
  }, [refreshWorkspacesMetadata]);

  return {
    workspacesMetadata,
    loadingWorkspacesMeta,
    error,
    refreshWorkspacesMetadata,
  };
};